<template>
    <div>
        <div class="d-flex flex-column my-1 border border-secondary">
            <b-alert
                v-if="!edit"
                show
                :variant="theNote.action === 'R' ? 'danger' : 'info'"
                class="d-flex p-3"
            >
                {{ theNote.notes }}
            </b-alert>
            <app-form-textarea-input
                v-else
                placeholder="Nota"
                id="comment"
                v-model="comment"
                :hasError="$v.comment.$error"
                errorMessage="Escriba el comentario"
                @input="$v.comment.$touch()"
            />
            <div class="d-flex justify-content-center">
                <div class="pr-2">
                    <h5>
                        <b-badge pill variant="secondary">{{
                            theNote.user.name
                        }}</b-badge>
                    </h5>
                </div>
                <div class="pl-2">
                    <h5>
                        <b-badge pill variant="secondary">{{
                            theNote.created_at | datetime
                        }}</b-badge>
                    </h5>
                </div>
            </div>
            <div v-if="edit">
                <b-row>
                    <b-col lg="4"></b-col>
                    <b-col lg="2" cols="6">
                        <b-btn
                            size="sm"
                            class="btn-block"
                            variant="danger"
                            @click="cancelCommentEdit()"
                            ><i class="fa fa-times" aria-hidden="true"></i
                        ></b-btn>
                    </b-col>
                    <b-col lg="2" cols="6">
                        <b-btn
                            size="sm"
                            class="btn-block"
                            variant="success"
                            @click="confirmEdition(theNote)"
                            ><i class="fa fa-check" aria-hidden="true"></i
                        ></b-btn>
                    </b-col>
                    <b-col lg="4"></b-col>
                </b-row>
            </div>
            <div v-else>
                <b-row v-if="user.id === theNote.user.id">
                    <b-col lg="4"></b-col>
                    <b-col lg="2" cols="6">
                        <b-btn
                            size="sm"
                            @click="editComment(theNote)"
                            variant="primary"
                            class="btn-block"
                            ><i class="fa fa-pencil"></i
                        ></b-btn>
                    </b-col>
                    <b-col lg="2" cols="6">
                        <b-btn
                            size="sm"
                            variant="danger"
                            @click="startRemove()"
                            class="btn-block"
                            ><i class="fa fa-trash"></i
                        ></b-btn>
                    </b-col>
                    <b-col lg="4"></b-col>
                </b-row>
            </div>
        </div>

        <app-pop-up title="Confirmación" :id="`the-note-remove_${note.id}`">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar esta nota?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="removeComment">
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    Eliminación
                </button>
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import tasksRepository from "../../../repositories/tasks.repository.js";
export default {
    props: {
        note: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            edit: false,
            comment: "",
            theNote: ""
        };
    },
    validations: {
        comment: { required }
    },
    watch: {
        note(val) {
            this.theNote = val;
        }
    },
    methods: {
        editComment(note) {
            this.edit = true;
            this.comment = note.notes;
        },
        cancelCommentEdit() {
            this.comment = "";
            this.edit = false;
        },
        startRemove() {
            this.$bus.$emit(`the-note-remove_${this.note.id}.open`);
        },
        removeComment() {
            const tr = { ...tasksRepository };
            tr.deleteNoteTask(this.note.id)
                .then(data => {
                    if (data.status) {
                        this.$bus.$emit("task-note.delete", {
                            taskId: this.note.task_id,
                            noteId: this.note.id
                        });
                        this.$bus.$emit(
                            `the-note-remove_${this.note.id}.close`
                        );
                        toastr.success(data.msg);
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("No se pudo borrar el comentario");
                });
        },
        confirmEdition(note) {
            const tr = { ...tasksRepository };
            const payload = {};
            payload.comment = this.comment;
            tr.updateNoteTask(payload, note.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.theNote = data.note;
                        this.edit = false;
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("No se pudo modificar el comentario");
                });
        }
    },
    created() {
        this.theNote = this.note;
    }
};
</script>
